import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "@/app/App.tsx";
import {
  queryClient,
  queryKeys,
} from "@/shared/lib/queryClient";
import AuthService from "@/shared/services/AuthService";

AuthService.initAuthFromStorage();

window.addEventListener("auth:sessionExpired", () => {
  queryClient.removeQueries({ queryKey: queryKeys.auth.all });
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
